import React, { useEffect } from 'react';
import { EducationSection } from '../components/EducationSection';
import { AwardsSection } from '../components/AwardsSection';
import { BoardsSection } from '../components/BoardsSection';
export function CredentialsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24" data-id="element-386">
      <EducationSection data-id="element-387" />
      <AwardsSection data-id="element-388" />
      <BoardsSection data-id="element-389" />
    </div>;
}